import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  status: "checking",
  nextStep: null,
  message: null,
  isLoading: false,
  user: null,
  rol: null,
};

const resetState = (state, keys) => {
  keys.forEach((key) => {
    state[key] = initialState[key];
  });
};

export const authSlice = createSlice({
  name: "auth",
  initialState,
  reducers: {
    notAuthenticated: (state, { payload }) => {
      state.status = "not-authenticated";
      state.message = {
        type: "not-authenticated",
        text: payload,
      };
    },
    onLoading: (state) => {
      state.isLoading = true;
      state.message = null;
    },
    onErrorMessage: (state, { payload }) => {
      state.isLoading = false;
      state.message = {
        type: "error",
        text: payload,
      };
    },
    onLogin: (state, { payload }) => {
      const { rol, state: stateUser, ...newUser } = payload;
      state.status = "authenticated";
      state.user = newUser;
      state.rol = rol;
      state.state = stateUser;
      resetState(state, ["isLoading", "message"]);
    },
    onChecking: (state) => {
      state.status = "checking";
      state.nextStep = null;
      state.isLoading = null;
    },
    onLogout: (state) => {
      state.status = "not-authenticated";
      resetState(state, ["user", "rol", "state"]);
    },
    onConfirmCode: (state, { payload }) => {
      state.nextStep = "confirm-code";
      state.user = payload;
      resetState(state, ["isLoading", "message"]);
    },
    onLoginMessage: (state, { payload }) => {
      state.message = {
        type: "login-message",
        text: payload,
      };
      state.isLoading = false;
    },
    onUpdateUser: (state, { payload }) => {
      const { admin } = payload;
      const { rol, state: stateUser, ...newUser } = admin;
      state.user = newUser;
    },
    updateDoctor: (state, { payload }) => {
      const { doctor } = payload;
      const { rol, state: stateUser, ...newDoctor } = doctor;
      state.user = {
        ...state.user,
        ...newDoctor,
      };
    },
  },
});

// Action creators are generated for each case reducer function
export const {
  notAuthenticated,
  onLoading,
  onErrorMessage,
  onLogin,
  onChecking,
  onLogout,
  onConfirmCode,
  onLoginMessage,
  onUpdateUser,
  updateDoctor,
} = authSlice.actions;
